import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import BackComponent from 'screens/back';
import { Table, Pagination, Tooltip, Input, CheckboxTable, Modal, DatePicker, Select } from 'components';
// AGREGADO: Importamos Colors para el estilo del link
import { Globals, checkPermission, Constants, Colors } from 'utils';
import { DiscountService } from 'services';
import { CleanIcon, TrashWhiteIcon, AddWhiteIcon, ConfirmIcon, StarIcon, EditIcon, TrashIcon, ChangeStatusIcon, SettingIcon } from 'assets/icons';
import CreateDiscount from './create-discount';
import moment from 'moment';
import CreateDiscountDefault from './create-discountDefault';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: '',
	status: ''
}

class Discounts extends React.Component<Props> {

	timer: any = undefined;

	state = {
		form: INITIAL_STATE,
		page: 1,
		last_page: 1,
		data: [],
		header: [
			'Código',
			'Porcentaje',
			'Desde',
			'Hasta',
			'Máximo de veces',
			'Veces utilizado',
			'Estatus',
			'Acciones'
		],
		visible_bulk_confirm: false,
		visible_confirm: false,
		visible_delete: false,
		visible: false,
		item: null,
		visible_default: false,

		// --- NUEVOS ESTADOS PARA EL MODAL DE DETALLES USO ---
		visible_usage_details: false,
		usage_details: [],
		usage_details_page: 1,
		usage_details_last_page: 1,
		usage_details_loading: false,
		usage_item_selected: null,
		// -------------------------------------------
	}

	componentDidMount() {
		this.getData(1);
	}

	getData = (page: number) => {
		console.log(this.props.user)
		this.setState({ page }, async () => {
			try {
				let params: any = {
					...this.state.form,
					page: this.state.page,
					user_id: this.props.user.id,
				}

				let res: any = await DiscountService.admin.get(params);
				this.setState({
					data: res.discounts.rows,
					last_page: res.discounts.count,
				})
			} catch (error) {
				console.log(error);
			}
		})
	}

	// --- NUEVA FUNCIÓN: Obtener detalles ---
	getUsageDetails = async (item: any, page: number = 1) => {
		// Abrimos modal y mostramos loading
		this.setState({
			visible_usage_details: true,
			usage_item_selected: item,
			usage_details_loading: true,
			usage_details_page: page
		});

		try {
			// Llamada al servicio con paginación
			const res: any = await DiscountService.admin.usageDetails({
				id: item.id,
				page: page,
			});

			this.setState({
				usage_details: res.usages,
				usage_details_last_page: res.total_pages,
				usage_details_loading: false
			});
		} catch (error) {
			console.log(error);
			this.setState({ usage_details_loading: false });
		}
	}
	// ---------------------------------------

	onChangeFilter = (input: string, value: any) => {
		this.setState({
			form: {
				...this.state.form,
				[input]: value
			}
		}, () => {
			if (this.timer) clearTimeout(this.timer);
			this.timer = setTimeout(() => {
				this.getData(1);
			}, 500);
		})
	}

	edit = (e: any, item: any) => {
		e.preventDefault();
		this.setState({ visible: true, item });
	}

	confirmChangeStatus = (e: any, item: any) => {
		e.preventDefault();
		this.setState({ visible_confirm: true, item });
	}

	confirmDelete = (e: any, item: any) => {
		e.preventDefault();
		this.setState({ visible_delete: true, item });
	}

	changeStatus = async () => {
		try {
			let item: any = this.state.item;
			await DiscountService.admin.changeStatus({ discount_id: item.id });
			this.setState({ visible_confirm: false, item: null });
			this.getData(1);
		} catch (error) {
			console.log(error);
		}
	}

	delete = async () => {
		try {
			let item: any = this.state.item;
			await DiscountService.admin.delete({ discount_id: item.id });
			this.setState({ visible_delete: false, item: null });
			this.getData(1);
		} catch (error) {
			console.log(error);
		}
	}

	onClose = () => {
		this.setState({ visible: false, item: null, visible_default: false });
		this.getData(1);
	}

	render() {
		const { visible, visible_confirm, visible_delete, visible_usage_details, usage_item_selected, data, visible_default, } = this.state;
		const item: any = this.state.item;
		const { user } = this.props;

		const isClient = user?.level_id === Constants.LEVELS.CLIENT;
		const isAdmin = user?.level_id === Constants.LEVELS.ADMIN;

		return (
			<div id="discounts">
				{!isClient && (
					<BackComponent />
				)}

				<div className="row justify-content-between">
					<div className="col-md-3">
						<h3>Descuentos</h3>
					</div>
					
					{/* COLUMNA DERECHA: Contenedor de Acciones */}
					<div className="col-md-6 text-right">

						{/* Botón 2: Configuración (Solo si es admin) */}
						{isAdmin && (
							<button
								className="btn btn-add"
								onClick={() => this.setState({ visible_default: true, item: null })}
							>
								<img src={SettingIcon} className="mr-1" alt="Config" /> {/* mr-1 separa icono del texto */}
								Configuración
							</button>
						)}

						{/* Botón 1: Agregar (Solo si tiene permiso) */}
						{checkPermission(Constants.MODULES.DISCOUNTS, 'write') && (
							<button
								className="btn btn-add mr-2"
								onClick={() => this.setState({ visible: true, item: null })}
								title="Crear nuevo descuento"
							>
								<img src={AddWhiteIcon} alt="Agregar" />
							</button>
						)}
					</div>

				</div>

				<div className="row row-filter">
					<div className="col-md-3">
						<Input
							placeholder="Buscar por código..."
							value={this.state.form.search}
							onChange={(e: any) => this.onChangeFilter('search', e.target.value)}
							icon={true}
						/>
					</div>
					<div className="col-md-3">
						<Select
							name='status'
							placeholder="Estatus"
							value={this.state.form.status}
							onChange={(e: any) => this.onChangeFilter('status', e.target.value)}
							options={[
								{ value: '', label: 'Todos' },
								{ value: Constants.DISCOUNT_STATUS.ACTIVE.toString(), label: 'Activo' },
								{ value: Constants.DISCOUNT_STATUS.INACTIVE.toString(), label: 'Inactivo' },
							]}
						/>
					</div>
				</div>

				<Table
					header={this.state.header}
					data={this.state.data.length}
				>
					{this.state.data.map((i: any, index: number) => {
						return (
							<tr key={index}>
								<td>{i.code}</td>
								<td>{i.percent}%</td>
								<td>{moment(i.since).format('DD/MM/YYYY')}</td>
								<td>{moment(i.until).format('DD/MM/YYYY')}</td>
								<td>{i.quantity}</td>

								{/* --- CAMBIO: Columna clickeable para abrir el modal --- */}
								<td>
									<p
										className="container-color"
										onClick={() => {
											// Solo abrimos si hay usos
											if (i.quantity_use > 0) this.getUsageDetails(i);
										}}
										style={{
											color: Colors.blue_link,
											cursor: 'pointer',
											textDecoration: 'underline',
											fontWeight: 'bold'
										}}
									>
										{i.quantity_use}
									</p>
								</td>
								{/* ---------------------------------------------------- */}

								<td>{i.status_text}</td>
								<td>
									{
										checkPermission(Constants.MODULES.DISCOUNTS, 'write') && (
											<Tooltip title="Editar">
												<a className="link-icon" href="#" onClick={(e: any) => this.edit(e, i)}>
													<img src={EditIcon} />
												</a>
											</Tooltip>
										)
									}
									{
										checkPermission(Constants.MODULES.DISCOUNTS, 'write') && (
											<Tooltip title={i.status == Constants.DISCOUNT_STATUS.ACTIVE ? 'Desactivar' : 'Activar'}>
												<a className="link-icon" href="#" onClick={(e: any) => this.confirmChangeStatus(e, i)}>
													<img src={ChangeStatusIcon} />
												</a>
											</Tooltip>
										)
									}
									{
										checkPermission(Constants.MODULES.DISCOUNTS, 'delete') && (
											<Tooltip title="Eliminar">
												<a className="link-icon" href="#" onClick={(e: any) => this.confirmDelete(e, i)}>
													<img src={TrashIcon} />
												</a>
											</Tooltip>
										)
									}
								</td>
							</tr>
						)
					})}
				</Table>

				<Pagination
					pages={this.state.last_page}
					onChangePage={this.getData}
					page={this.state.page}
				/>

				<div className={`container-modal-right ${visible ? 'active' : ''}`}>
					{
						visible && (
							<CreateDiscount
								item={this.state.item}
								title={`${this.state.item ? 'Editar' : 'Nuevo'} Descuento`}
								onClose={() => this.onClose()}
								user={this.props.user}
							/>
						)
					}
				</div>

				<div className={`container-modal-right ${visible_default ? 'active' : ''}`}>
					{
						visible_default && (
							<CreateDiscountDefault
								item={this.state.item}
								title={`Descuento por defecto`}
								onClose={() => this.onClose()}
								user={this.props.user}
							/>
						)
					}
				</div>

				<Modal
					className="modal-discounts-confirm-status"
					visible={visible_confirm}
					title=""
					centered
					onClose={() => this.setState({ visible_confirm: false, item: null })}
				>
					<div id="modal-discounts-confirm-status">
						<img src={ConfirmIcon} />
						<h3>¿Está seguro de {item?.status == Constants.DISCOUNT_STATUS.ACTIVE ? 'Desactivar' : 'Activar'} el descuento?</h3>
						<div className="row">
							<div className="col-6 text-center">
								<button className="btn" onClick={() => this.changeStatus()}>
									Aceptar
								</button>
							</div>
							<div className="col-6 text-center">
								<button className="btn btn-cancel" onClick={() => {
									this.setState({
										visible_confirm: false,
										item: null
									});
								}}>
									Cancelar
								</button>
							</div>
						</div>
					</div>
				</Modal>

				<Modal
					className="modal-discounts-confirm-delete"
					visible={visible_delete}
					title=""
					centered
					onClose={() => this.setState({ visible_delete: false, item: null })}
				>
					<div id="modal-discounts-confirm-delete">
						<img src={ConfirmIcon} />
						<h3>¿Está seguro de eliminar el descuento?</h3>
						<div className="row">
							<div className="col-6 text-center">
								<button className="btn" onClick={() => this.delete()}>
									Aceptar
								</button>
							</div>
							<div className="col-6 text-center">
								<button className="btn btn-cancel" onClick={() => {
									this.setState({
										visible_delete: false,
										item: null
									});
								}}>
									Cancelar
								</button>
							</div>
						</div>
					</div>
				</Modal>

				{/* --- NUEVO MODAL AGREGADO --- */}
				<Modal
					className="modal-discounts-details"
					visible={visible_usage_details}
					title=""
					centered
					onClose={() => this.setState({ visible_usage_details: false, usage_item_selected: null })}
				>
					<div id="modal-discounts-details">
						<div style={{ padding: '20px' }}>
							{this.state.usage_details_loading && this.state.usage_details.length === 0 ? (
								<p className="text-center">Cargando datos...</p>
							) : (
								<>
									<Table
										data={this.state.usage_details.length}
										header={['Cliente', 'Email', 'Usos']}
									>
										{this.state.usage_details.map((u: any, idx: number) => (
											<tr key={idx}>
												<td>
													<div style={{ display: 'flex', alignItems: 'center' }}>
														{u.user && u.user.photo ? (
															<img
																src={u.user.photo}
																style={{ width: 30, height: 30, borderRadius: '50%', marginRight: 10, objectFit: 'cover' }}
																alt="avatar"
															/>
														) : (
															<div style={{ width: 30, height: 30, borderRadius: '50%', marginRight: 10, backgroundColor: '#ccc' }} />
														)}
														<span>{u.user ? `${u.user.name} ${u.user.lastname}` : 'Usuario eliminado'}</span>
													</div>
												</td>
												<td>{u.user?.email || '-'}</td>
												<td style={{ textAlign: 'center', fontWeight: 'bold' }}>
													{u.user?.quantity_use}
												</td>
											</tr>
										))}
										{this.state.usage_details.length === 0 && !this.state.usage_details_loading && (
											<tr>
												<td colSpan={3} className="text-center">No hay registros disponibles.</td>
											</tr>
										)}
									</Table>
								</>
							)}
						</div>
					</div>

				</Modal>
				{/* ---------------------------- */}

			</div>
		);
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Discounts);